import { EventCalendarList, EventCard, FormAttend, FormShareEvent, FormSponsor, Link } from "Components"
import Config from "Data"
import React from "react"
import Collapsible from "react-collapsible"
import styled from "styled-components"
import { theme } from "Theme"
import { EventCardEmpty, Wrapper } from "Styles"

const Content = styled.div`
  width: 100%;
  padding: 1rem 0 0;
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
  .Collapsible {
    overflow: hidden;
    .Collapsible__trigger {
      color: ${theme.colors.black.base};
      background: ${theme.colors.white.light};
      font-weight: bold;
      font-size: ${theme.fontSize.p};
      width: 100%;
      max-width: ${theme.layout.base};
      padding: 1rem;
      margin: 0;
      cursor: pointer;
      position: relative;
      border: 1px solid ${theme.colors.white.grey};
      &:hover {
        color: ${theme.colors.primary.base};
        &:after {
          content: "";
          display: inline-block;
          height: 0.5em;
          vertical-align: bottom;
          width: 100%;
          margin-right: -100%;
          margin-left: 10px;
          border-top: none;
        }
      }
      &:before {
        color: ${theme.colors.primary.base};
        background-color: transparent;
        border: 1px solid ${theme.colors.white.grey};
        background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDE4IDEyIj4KICA8cGF0aCBmaWxsPSIjMGUxZTI1IiBkPSJNMy4xNC42NjdsNS4wMSA0LjU5Yy40Ny40MyAxLjIzLjQzIDEuNyAwbDUuMDEtNC41OUwxOCAzLjU0NCA5Ljg1IDExLjAxYy0uNDcuNDMtMS4yMy40My0xLjcgMEwwIDMuNTQ1IDMuMTQuNjY3eiIvPgo8L3N2Zz4K);
        background-position: center;
        background-repeat: no-repeat;
        background-size: 0.8em;
        content: "";
        height: 2rem;
        position: absolute;
        right: 8px;
        top: 8px;
        transition: ${theme.transitions.default.transition};
        width: 2rem;
        border-radius: ${theme.borderRadius.elements};
      }
      &:after {
        content: "";
        display: inline-block;
        height: 0.5em;
        vertical-align: bottom;
        width: 100%;
        margin-right: -100%;
        margin-left: 10px;
        border-top: none;
      }
    }
    &.collapsible-open {
      .Collapsible__contentOuter {
        margin: 1rem 0;
      }
      .Collapsible__trigger.is-open {
        &:before {
          transform: rotate(-180deg);
        }
      }
    }
  }
`

const Grid = styled.div`
  margin: 0 auto;
  width: 100%;
  max-width: ${theme.layout.base};
`

const EventsListGrid = styled.div`
  display: grid;
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
    grid-template-columns: repeat(auto-fill, minmax(32%, 1fr));
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
  grid-gap: 1rem;
  .option-card {
    padding: 1rem;
    box-shadow: ${theme.shadow.feature.small.default};
  }
`

class EventListCollapse extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      currentModal: null,
      shareEvent: null,
    }
  }

  componentDidMount() {
    this.setState({
      currentModal: null,
      shareEvent: null,
    })
  }

  toggleModal = (key, event) => (e) => {
    e.preventDefault()
    if (this.state.currentModal) {
      this.handleModalCloseRequest()
      return
    }

    this.setState({
      ...this.state,
      currentModal: key,
      shareEvent: event,
    })
  }

  handleOnAfterOpenModal = () => {
    // when ready, we can access the available refs.
  }

  handleModalCloseRequest = () => {
    // opportunity to validate something and keep the modal open even if it
    // requested to be closed
    this.setState({
      ...this.state,
      currentModal: null,
    })
  }

  render() {
    const { currentModal } = this.state
    const {
      big,
      dark,
      layout,

      data,
      region,
    } = this.props

    return (
      <Wrapper layout={layout} dark={dark ? 1 : undefined} big={big}>
        <Content>
          <Collapsible
            transitionTime={250}
            triggerTagName={"h4"}
            trigger={`${region}`}
            className={"collapsible-default"}
            openedClassName={"collapsible-open"}>
            <Grid>
              <EventsListGrid>
                {data.map((event, i) => (
                  <EventCard key={i} className={`aaa`}>
                    <EventCalendarList
                      full={true}
                      featured={false}
                      photo={""}
                      node={event.node}
                      key={event.node.id}
                      event={event.node}
                      attend={this.toggleModal(`${"modal_attend"}_${i}`, event.node)}
                      sponsor={this.toggleModal(`${"modal_sponsor"}_${i}`, event.node)}
                      share={this.toggleModal(`${"modal_share_event"}_${i}`, event.node)}

                      // share={this.toggleModal("modal_share", {
                      //   shareEvent: event.node,
                      //   showEvents: false,
                      // })}
                      // attend={attend}
                      // sponsor={sponsor}
                      // share={share}
                      // calendar={this.toggleModal(MODAL_ADD_CALENDAR, data.node.event)}
                    />
                    <FormAttend
                      showEvents={this.state.showEvents}
                      node={this.state.shareEvent}
                      title={this.state.shareEvent ? `Attend ${Config.brand} ${this.state.shareEvent}` : "null"}
                      subtitle="Interested in attending CISOcamps events? (InfoSec leaders only)"
                      // image={this.state.shareEvent ? this.state.shareEvent.childrenFile[0].childImageSharp : "null"}
                      isOpen={currentModal === `${"modal_attend"}_${i}`}
                      onAfterOpen={this.handleOnAfterOpenModal}
                      onRequestClose={this.handleModalCloseRequest}
                      closeModal={this.toggleModal(`${"modal_attend"}_${i}`, {
                        shareEvent: null,
                        showEvents: false,
                      })}
                    />
                    <FormSponsor
                      showEvents={this.state.showEvents}
                      node={this.state.shareEvent}
                      title={this.state.shareEvent ? `Sponsor ${Config.brand} ${this.state.shareEvent.city}` : "null"}
                      subtitle="Interested?"
                      // image={this.state.shareEvent ? this.state.shareEvent.childrenFile[0].childImageSharp : "null"}
                      options={false}
                      optionsLink={false}
                      isOpen={currentModal === `${"modal_sponsor"}_${i}`}
                      onAfterOpen={this.handleOnAfterOpenModal}
                      onRequestClose={this.handleModalCloseRequest}
                      closeModal={this.toggleModal(`${"modal_sponsor"}_${i}`, {
                        shareEvent: null,
                        showEvents: false,
                      })}
                    />
                    <FormShareEvent
                      event={this.state.shareEvent}
                      node={this.state.shareEvent}
                      title={this.state.shareEvent ? `Share ${Config.brand} ${this.state.shareEvent}` : "null"}
                      subtitle="Interested"
                      image={this.state.shareEvent ? this.state.shareEvent.childFile : "null"}
                      isOpen={currentModal === `${"modal_share_event"}_${i}`}
                      onAfterOpen={this.handleOnAfterOpenModal}
                      onRequestClose={this.handleModalCloseRequest}
                      closeModal={this.toggleModal(`${"modal_share_event"}_${i}`, {
                        shareEvent: null,
                        showEvents: false,
                      })}
                    />
                  </EventCard>
                ))}
                <EventCardEmpty className={``}>
                  <Link to={"/events/"}>
                    <div className="event-list-contents">
                      <div className="event-list-featured">
                        <p className="event-card-city">{`Browse more Events >`}</p>
                      </div>
                    </div>
                  </Link>
                </EventCardEmpty>
              </EventsListGrid>
            </Grid>
          </Collapsible>
        </Content>
      </Wrapper>
    )
  }
}

export default EventListCollapse
